import { API_URL } from '../config/connect';

// Dynamic TURN credentials for WebRTC audio calls. STUN alone fails on
// symmetric NAT (mobile carriers, corporate Wi-Fi), so a TURN relay is
// required in production. Credentials are fetched from the backend so they
// can be rotated without rebuilding the client, and fall back to the static
// env-based config (REACT_APP_TURN_*) when the endpoint is unavailable.
let cached = null;
let cacheExpiresAt = 0;
const NEGATIVE_TTL = 30 * 1000;

const normalize = (data) => {
  if (!data) return null;
  const src = data.turn || data.iceServers || data.ice_servers || data;
  const arr = Array.isArray(src) ? src : [src];
  const servers = arr
    .map((c) => ({
      urls: c.urls || c.url,
      username: c.username || c.user || '',
      credential: c.credential || c.pass || '',
    }))
    .filter((c) => c.urls);
  return servers.length ? servers : null;
};

const getTurnCredentials = async () => {
  if (cached !== null && Date.now() < cacheExpiresAt) return cached;
  try {
    const accessToken = localStorage.getItem('access_token');
    const headers = { Accept: 'application/json' };
    if (accessToken) headers['Authorization'] = `Bearer ${accessToken}`;
    const res = await fetch(`${API_URL}/api/v1/turn/credentials`, {
      headers,
      credentials: 'include',
    });
    if (!res.ok) {
      cached = null;
      cacheExpiresAt = Date.now() + NEGATIVE_TTL;
      return null;
    }
    const data = await res.json();
    const servers = normalize(data);
    cached = servers;
    cacheExpiresAt = Date.now() + (data && data.ttl ? data.ttl * 1000 : 5 * 60 * 1000);
    return servers;
  } catch {
    cached = null;
    cacheExpiresAt = Date.now() + NEGATIVE_TTL;
    return null;
  }
};

export default getTurnCredentials;